export const getTrClassName = (isButtonDisabled) => {
  const className = 'InfoSectionUsersAddSection';
  return isButtonDisabled ? `${className}--disabled` : className
}